export const ALWAYS_AVAILABLE_OPTION = {
  id: 0,
  label: 'Always Available',
  children: [],
};

export const SUICIDE_OPTION = {
  id: 38,
  label: 'Suicide',
  children: [],
};

const isItemActive = (item) => {
  if (!item) return false;
  if (item.is_active === false) return false;
  if (item.IsActive === 0 || item.IsActive === false) return false;
  return true;
};

const getSortOrder = (item) => item?.SortOrder ?? item?.sort_order ?? item?.value ?? 0;

const sortByOrder = (items = []) =>
  [...items].sort((a, b) => getSortOrder(a) - getSortOrder(b));

export const extractFormFieldsData = (result) =>
  result?.original?.data || result?.data || {};

const mapStatusItems = (items = []) =>
  sortByOrder(items.filter(isItemActive)).map((item) => ({
    id: item.value,
    status: item.label,
    key: item.value,
  }));

export const normalizeFollowUpTypeValue = (label = '') => {
  const trimmed = typeof label === 'string' ? label.trim() : label;
  if (!trimmed) return trimmed;
  if (trimmed.toLowerCase().includes('rededication')) return 'Rededication';
  return trimmed;
};

export const normalizeFollowUpTypeSelection = (selection = '') => {
  if (!selection) return '';

  return selection
    .split(',')
    .map((part) => normalizeFollowUpTypeValue(part.trim()))
    .filter(Boolean)
    .join(', ');
};

export const normalizeCallTypesForForms = (callTypes = []) =>
  sortByOrder(callTypes.filter(isItemActive)).map((callType) => ({
    id: callType.value,
    type: callType.label,
    key: callType.value,
    help_text: callType.help_text,
    children: sortByOrder((callType.children || []).filter(isItemActive)).map(
      (child) => child.label
    ),
  }));

export const normalizeInventoryCallTypes = (callTypes = []) => {
  const normalized = sortByOrder(callTypes.filter(isItemActive))
    .filter(
      (callType) =>
        callType.label !== 'Other Request' &&
        callType.value !== SUICIDE_OPTION.id &&
        callType.label !== SUICIDE_OPTION.label
    )
    .map((callType) => ({
      id: callType.value,
      label: callType.label,
      children: sortByOrder((callType.children || []).filter(isItemActive)).map(
        (child) => ({
          id: child.value,
          label: child.label,
        })
      ),
    }));

  return [ALWAYS_AVAILABLE_OPTION, SUICIDE_OPTION, ...normalized];
};

export const normalizeFollowUpTypes = (followups = []) =>
  sortByOrder(followups.filter(isItemActive)).map((item) => ({
    id: item.value,
    type: normalizeFollowUpTypeValue(item.label),
    label: item.label,
    key: item.value,
  }));

export const normalizeAgeRanges = (ageGroups = []) =>
  sortByOrder(ageGroups.filter(isItemActive)).map((item) => ({
    id: item.value,
    range: item.label,
    key: item.value,
  }));

export const normalizeGenders = (genders = []) =>
  sortByOrder(genders.filter(isItemActive)).map((item) => ({
    id: item.value,
    gender: item.label,
    value: item.label.toLowerCase(),
    key: item.value,
  }));

export const normalizeDispositions = (dispositions = []) =>
  sortByOrder(dispositions.filter(isItemActive)).map((item) => ({
    id: item.value,
    disposition: item.label,
    key: item.value,
  }));

export const normalizeMinistryFormOptions = (options = []) =>
  sortByOrder(options.filter(isItemActive)).map((item) => ({
    id: item.id ?? item.value,
    value: item.value ?? item.label ?? "",
    label: item.label ?? item.value ?? "",
  }));

export const normalizeFormFields = (result) => {
  const data = extractFormFieldsData(result);

  return {
    callTypes: normalizeCallTypesForForms(data.call_types || []),
    followUpTypes: normalizeFollowUpTypes(data.followups || []),
    ageRanges: normalizeAgeRanges(data.age_groups || []),
    genders: normalizeGenders(data.genders || []),
    dispositions: normalizeDispositions(data.dispositions || []),
    mentalStatus: mapStatusItems(data.mentalStatus || []),
    maritialStatus: mapStatusItems(data.maritalStatus || []),
    financialStatus: mapStatusItems(data.financialStatus || []),
    livingArrangement: mapStatusItems(data.livingArrangement || []),
    inventoryCallTypes: normalizeInventoryCallTypes(data.call_types || []),
    ministryFormOptions: normalizeMinistryFormOptions(
      data.ministryFormOptions || []
    ),
  };
};

export const EMPTY_FORM_FIELDS = {
  callTypes: [],
  followUpTypes: [],
  ageRanges: [],
  genders: [],
  dispositions: [],
  mentalStatus: [],
  maritialStatus: [],
  financialStatus: [],
  livingArrangement: [],
  inventoryCallTypes: [],
  ministryFormOptions: [],
};
